import { Button, Stack, Typography, Box, Avatar, Menu, Breadcrumbs, Modal, Skeleton, Grid } from '@mui/material'
import placeholder from '../../../../assets/placeholder_artist.jpg'
import '../../Album.module.css'
import React from 'react'
import AMBadgeListenIn from '../../../../assets/AMBadgeListenIn.svg'
import { useGetAlbumQuery } from '../../../../api/albumApiSlice'
import { Link, useParams } from 'react-router-dom'
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic'
import ShareIcon from '@mui/icons-material/Share'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import FavoriteIcon from '@mui/icons-material/Favorite'
import Pause from '@mui/icons-material/Pause'
import { pause, playAlbum } from '../../../../services/MusicPlayerApi'
import withMK from '../../../../hoc/withMK'
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import InstagramIcon from '@mui/icons-material/Instagram'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useGetUserQuery, useLikeByTypeMutation } from '../../../../api/userApiSlice'
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility'
import AlbumIcon from '@mui/icons-material/Album'
import { useDispatch } from 'react-redux'
import { setShowSubscribe } from '../../../../actions/mainSlice'
const parse = require('html-react-parser')


const style = {
    position: 'absolute',
    top: '40%',
    left: '31%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'primary.main',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    width: '22vw',
    color: '#fff'
  };

interface AlbumSideMenuProps extends MKProps {
}

const AlbumSideMenu = (props: AlbumSideMenuProps) => {
    let { id } = useParams()
    const dispatch = useDispatch()
    const currentAlbumName = props.mk && props.mk.instance.queue.currentItem ? props.mk.instance.queue.currentItem.albumName : null
    const playing = props.mk?.instance?.isPlaying
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const openMenu = Boolean(anchorEl)
    const [likeAlbum] = useLikeByTypeMutation()
    const [open, setOpen] = React.useState(false)

    const handleOpen = () => {
      setOpen(true)
    }

    const handleClose = () => {
      setOpen(false)
    }

    const handleClickOpen = () => {
        dispatch(setShowSubscribe({showSubscribe: true}))
    }  
  
    const handleClickShare = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const {
        data: user,
        refetch: refetchUser
    } = useGetUserQuery({})
    

    const {
        data: albumLiked,
    } = useGetAlbumQuery({id})

    const likeAlbumById = async (ID: string) => {
        try {
            const like = await likeAlbum({target_id: ID, type: 'album'}).unwrap()
            if(like) {
                console.log('TODO: Use like')
            }
            refetchUser()
        } catch (error) {
            handleClickOpen()
        }
    }

    return albumLiked.album || albumLiked.mainArtist ? (
        <Grid size={{ lg: 4, xs: 12}} sx={{height: {xs:'35%', md:'50%',lg:'100%'}}}>
            <Stack sx={{
                height: '100%', 
                borderRadius: '16px',
                overflow: 'hidden', 
                backgroundImage: `url(${albumLiked.album && albumLiked.album.apple_artwork_url ? albumLiked.album.apple_artwork_url.replace("cw.png","cc.png").replace('{h}', albumLiked.album.apple_artwork_width).replace('{w}', albumLiked.album.apple_artwork_width) : ''})`, 
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center'}}
            >
                <Stack direction={{xs:'row', md:'row', lg:'column'}} sx={{backdropFilter: 'blur(20px)  brightness(70%)', height: '100%', position: 'relative', borderRadius: '16px'}} >

                    <Breadcrumbs aria-label="breadcrumb" color={'#fff'} sx={{ p: 2, color: 'white', width:'100%', '& .MuiBreadcrumbs-li': {maxWidth: '50%'}}}>
                        <Link
                            style={{ display: 'flex', alignItems: 'center'}}
                            color="white"
                            to={"/artist/" + albumLiked.mainArtist._id }
                        >
                            <SettingsAccessibilityIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            <Typography variant='caption' sx={{overflow: 'hidden', textOverflow: 'ellipsis'}}>{albumLiked.mainArtist?.artist_name?.length > 20 ? `${albumLiked.mainArtist.artist_name.slice(0, 19)}...` : albumLiked.mainArtist.artist_name}</Typography>
                        </Link>
                        <Link
                            style={{ display: 'flex', alignItems: 'center'  }}
                            color="white"
                            to={"/album/"+albumLiked.album._id}
                        >
                            <AlbumIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            <Typography variant='caption' sx={{overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 700}}>{albumLiked.album.apple_name ? albumLiked.album.apple_name.length > 20 ? `${albumLiked.album.apple_name.slice(0, 19)}...` : albumLiked.album.apple_name : ''}</Typography>
                        </Link>
                    </Breadcrumbs>

                    <Stack 
                        direction="row" 
                        alignItems="center" 
                        sx={{ 
                            position: { xs: 'absolute', md: 'absolute', lg:'inherit' }, 
                            width: { xs: '35%', md: '18%', lg:'inherit' }, 
                            left: { xs: '0', md: '16px', lg:'inherit' }, 
                            top: { xs: '50%', md: '50%', lg:'inherit' }, 
                            padding: 2,
                            transform: { xs: 'translateY(-50%)', md: 'translateY(-50%)', lg:'none'}
                            }}
                        >
                        <Box sx={{position: 'relative', width:  '100%'}}>
                            <Avatar 
                                variant='square' 
                                alt={albumLiked.album.apple_artist_name} src={albumLiked.album.apple_artwork_url ? albumLiked.album.apple_artwork_url.replace("cw.png","cc.png").replace('{h}', albumLiked.album.apple_artwork_width).replace('{w}', albumLiked.album.apple_artwork_width) : placeholder} 
                                sx={{width: '100%', height:'100%', borderRadius: '16px'}} 
                            />
                            <Grid size={3} sx={{position: 'absolute', bottom: '0', p: 1, width: '100%', maxWidth: '300px'}}>
                                <a href={albumLiked.album.apple_url} target='blank'><img alt='apple music link' width={'100%'} src={AMBadgeListenIn} /></a>                
                            </Grid>
                        </Box>  
                    </Stack>

                    <Stack direction={{sx:'column', md:'row', lg:'row'}} alignContent={'center'} alignItems={'center'} alignSelf={'center'}  sx={{position: {xs:'absolute', md:'absolute', lg:'inherit'}, zIndex: 1000, right: 0}}>
                        <Stack direction={'row'} sx={{m: 1}}>
                            {
                                playing && currentAlbumName === albumLiked.album.apple_name
                                ? <Button onClick={() => pause()} sx={{p: 2, mr: 1, borderRadius: '16px', backgroundColor: '#00000080'}}> <Pause htmlColor={'white'} fontSize='small' /> </Button>
                                : <Button onClick={() => playAlbum({ id: albumLiked.album.apple_id+'', apple_store: albumLiked.album.apple_store}, 0)} sx={{p: 2, mr: 1, borderRadius: '16px', backgroundColor: '#00000080'}}> <PlayArrowIcon htmlColor={'white'} fontSize='small' /> </Button>
                            }
                            <Button onClick={() => likeAlbumById(albumLiked.album._id)} sx={{p: 2, m: 0, borderRadius: '16px', backgroundColor: '#00000080'}}> <FavoriteIcon htmlColor={albumLiked && user && user.likes && user.likes.filter((like: any) => like.target_id === albumLiked.album._id).length > 0 ? '#FF5964' : '#ffffff'} fontSize='small' /> </Button>
                        </Stack>
                        <Stack direction={'row'}>
                            <Button sx={{ p: 2, mr: 1, borderRadius: '16px', backgroundColor: '#00000080'}}> <LibraryMusicIcon htmlColor={'white'} fontSize='small' /> </Button>
                            <Button onClick={handleClickShare} sx={{ p: 2, m: 0, ml: 0, borderRadius: '16px', backgroundColor: '#00000080'}}> <ShareIcon htmlColor={'white'} fontSize='small' /> </Button>
                            <Menu
                                id="share-menu"
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                    }}
                                anchorEl={anchorEl}
                                open={openMenu}
                                onClose={handleCloseMenu}
                                sx={{p: 0}}
                            >
                                <Button><FacebookIcon sx={{p: 2}}/> </Button>
                                <Button><TwitterIcon sx={{p: 2}}/> </Button>
                                <Button><InstagramIcon sx={{p: 2}}/> </Button>
                                <Button><WhatsAppIcon sx={{p: 2}}/> </Button>
                            </Menu>
                        </Stack>
                    </Stack>

                    <Typography variant='h3' sx={{fontWeight: 800, fontSize: '3vmin', pl: 2, position: {xs:'absolute', md:'absolute', lg:'inherit' }, display: {xs:'none', md:'none', lg:'block' } }}>
                        {albumLiked.album.apple_name}
                    </Typography>

                    <Box className={'content'} sx={{ pl: 2, position: {xs:'absolute', md:'absolute', lg:'inherit' }, zIndex: 0, bottom: 0, right: 0 }}>
                    {
                        albumLiked.album.apple_notes && albumLiked.album.apple_notes.length > 0 
                        ? 
                        <Box sx={{ p: 0, m: 0}}>
                            <Grid container>
                                <Grid size={8}>
                                    <Button onClick={handleOpen} sx={{color: 'white!important', textDecoration: 'underline', textTransform: 'initial', p: 0 }} >Notes sur l'album</Button>
                                </Grid>
                                <Grid size={4}>
                                    <Typography sx={{pr: 2, textAlign: 'right'}}><i>{'Sorti le ' + (new Date(albumLiked.album.apple_release_date)).toLocaleDateString()}</i></Typography>
                                </Grid>
                            </Grid>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                            <Box sx={style}>
                            {
                                parse(albumLiked.album.apple_notes)
                            }
                            </Box>
                            </Modal>
                        </Box>
                        : 
                            <Typography sx={{pr: 2, pb: 1, textAlign: 'right'}}><i>{'Sorti le ' + (new Date(albumLiked.album.apple_release_date)).toLocaleDateString()}</i></Typography>
                    }
                    </Box>

                    <Typography variant='h3' sx={{fontWeight: 800, fontSize: '3vmin', pl: 2, position: 'absolute', left: '8px', bottom: 0, p:2, display: {xs:'block', md:'block', lg:'none' } }}>
                        {albumLiked.album.apple_name}
                    </Typography>

                    <Grid container alignItems={'flex-end'} sx={{p: 2, position: {xs:'absolute', md:'inherit', lg:'inherit'}, display: {xs:'none', md:'flex', lg:'flex'}, height: '100%', bottom: '16px', left: 0, zIndex: -1, width: '100%', textAlign: 'right' }}>
                        <Grid size={12}>
                            <Typography className={'credits'}>{albumLiked.album.record_label ? albumLiked.album.record_label.name.length > 120 ? albumLiked.album.record_label.name.slice(0, 119)+'...' : albumLiked.album.record_label.name : '--'}</Typography>                
                            <Typography className={'credits'}>{albumLiked.album.apple_copyright && albumLiked.album.apple_copyright.length > 120 ? albumLiked.album.apple_copyright.slice(0,119)+'...' : albumLiked.album.apple_copyright }</Typography> 
                        </Grid>
                    </Grid>                    
                </Stack>
            </Stack>
        </Grid>
  ) : <Skeleton />
}


const bindings = {
    [MusicKit.Events.mediaItemDidChange]: 'mediaItem',
    [MusicKit.Events.queueItemsDidChange]: 'queueItems',
    [MusicKit.Events.queuePositionDidChange]: 'queuePosition',
    [MusicKit.Events.playbackStateDidChange]: 'playbackState',
}

export default withMK( AlbumSideMenu, bindings )